import React, { useState } from 'react';
import { TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { sortRows } from './helpers';
import CardPaper from './components/CardPaper';
import MuiTable from './components/Table/MuiTable';
import TableHeaderCell from './components/Table/TableHeaderCell';
import MuiTableSortLabel from './components/Table/MuiTableSortLabel';

export default function TopLines(props){
  const [orderBy, setOrderBy] = useState("totalTime");
  const [order, setOrder] = useState("desc");

  const { rows } = props;
  const sortedRows = sortRows(rows, orderBy, order);

  const handleRequestSort = (property) => {
    const isAsc = orderBy == property && order == 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return <CardPaper>
    <h3>{'Top 5 Lines'.translate()}</h3>
    <TableContainer>
      <MuiTable>
        <TableHead>
          <TableRow>
            <TableHeaderCell active={orderBy == "lineName"}>
              <MuiTableSortLabel
                active={orderBy == "lineName"}
                direction={orderBy == "lineName" ? order : 'asc'}
                onClick={()=> handleRequestSort("lineName")}
              >
                {'Line'.translate()}
              </MuiTableSortLabel>
            </TableHeaderCell>
            <TableHeaderCell active={orderBy == "avgTime"}>
              <MuiTableSortLabel
                active={orderBy == "avgTime"}
                direction={orderBy == "avgTime" ? order : 'asc'}
                onClick={()=> handleRequestSort("avgTime")}
              >
                {'Avg. Time'.translate()}
              </MuiTableSortLabel>
            </TableHeaderCell>
            <TableHeaderCell active={orderBy == "totalTickets"}>
              <MuiTableSortLabel
                active={orderBy == "totalTickets"}
                direction={orderBy == "totalTickets" ? order : 'asc'}
                onClick={()=> handleRequestSort("totalTickets")}
              >
                {'TTL TKTS'.translate()}
              </MuiTableSortLabel>
            </TableHeaderCell>
            <TableHeaderCell active={orderBy == "totalTime"}>
              <MuiTableSortLabel
                active={orderBy == "totalTime"}
                direction={orderBy == "totalTime" ? order : 'asc'}
                onClick={()=> handleRequestSort("totalTime")}
              >
                {'TTL Time'.translate()}
              </MuiTableSortLabel>
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, index) => (
            <TableRow key={index}>
              <TableCell size="small">
                {row.lineName || "N/A"}
              </TableCell>
              <TableCell size="small">{row.avgTime}</TableCell>
              <TableCell size="small">{row.totalTickets}</TableCell>
              <TableCell size="small">{
                row.totalTime 
                  ? row.totalTime.toLocaleString()
                  : 0
              }</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  </CardPaper>
}
